import { SysConst as SC } from '@/trials/plugins/const';
import round from '@/trials/lib/round';

/**
 * 予測データのカラム情報を保持するクラス\
 * 1カラムにつき1つインスタンスが生成される想定です。
 */
export default class PredictColumn {
    /**
     * カラム名
     */
    public name: string;

    /**
     * 有効データの数
     */
    public validCount: number = 0;

    /**
     * 欠損値の数
     */
    public invalidCount: number = 0;

    /**
     * 欠損値の割合
     */
    public invalidRatio: number = 0;

    /**
     * 数値データを配列で保持
     */
    public numberData: any[] = [];

    /**
     * 文字列データ\
     * 文字列をキーに、出現数を値として保持
     */
    public stringData: { [key: string]: number } = {};

    /**
     * データ型\
     * number or string のみの想定ですが、拡張できるよう文字列として保持
     */
    public type: string = '';

    /**
     * データ数の合計
     */
    public totalCount: number = 0;

    /**
     * カテゴリとして使用された値を保持
     * カテゴリ : 文字列データの際の値
     */
    public categories: any[] = [];

    /**
     * コンストラクタ
     * @param name カラム名
     */
    constructor(name: string) {
        this.name = name;
    }

    /**
     * 新しく出現したカテゴリを追加
     * @param category カテゴリ
     */
    private _addCategories(category: string) {
        if (!this.categories.includes(category)) {
            this.categories.push(category);
        }
    }

    /**
     * カラムにデータを追加します
     * @param val カラムのデータ
     */
    public addData(val: any) {
        this.totalCount++;

        // 欠損チェック
        if (val == null) {
            this.invalidCount++;

            // 欠損値の場合は、ここで処理終了
            return;
        }

        this.validCount++;

        // 型チェック
        if (this.type == '') {
            const type = isNaN(val) ? SC.InputData.Type.STRING : SC.InputData.Type.NUMBER;
            this.type = type;
        }

        // データ型に応じたデータ追加処理
        if (this.type == SC.InputData.Type.NUMBER) {
            this.numberData.push(val);
        } else {
            if (!(val in this.stringData)) {
                this.stringData[val] = 0;
                this._addCategories(val);
            }
            this.stringData[val] += 1;
        }
    }

    /**
     * 欠損値の割合を計算します
     */
    public calcInvalidRatio(): void {
        const ratio = (this.invalidCount / this.totalCount) * 100;
        this.invalidRatio = round(ratio, 2);
    }

    /**
     * カテゴリリストをソートします
     */
    public sortCategory(): void {
        this.categories.sort();
    }
}
